import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconUnblock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUnblock"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M5.5 18.5L10 14" stroke="currentColor"/><Path d="M14 10L18.5 5.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconUnblock;
